export default class QueryParameterError extends Error {
  isQueryParameterError = true
}

export function isQueryParameterError(e: unknown): e is QueryParameterError {
  return typeof e === 'object' && e !== null && (e as QueryParameterError).isQueryParameterError === true
}
